import i18n from '@/configured/vue-i18n';

/**
 * This needs to be a function in order to delay evaluation of the translated strings
 * to a point in time where the translations are available in the configured i18n instance.
 */
function rules() {
  return {
    email: [
      {
        required: true,
        type: 'email',
        message: i18n.i18n.t('authenticationEmailInvalid'),
        trigger: 'blur',
      },
    ],
    password: [
      {
        required: true,
        min: 6,
        message: i18n.i18n.t('authenticationPasswordInvalid'),
        trigger: 'blur',
      },
    ],
  };
}

export default {
  rules,
};
